import {Component, Input, OnInit} from '@angular/core';
import {DbActiveModal} from "../../../../../modules/modal/modal-ref";

@Component({
    selector: 'db-remove-boosted-page-dialog',
    templateUrl: './remove-boosted-page-dialog.component.html',
    styleUrls: ['./remove-boosted-page-dialog.component.scss'],
    standalone: false
})
export class RemoveBoostedPageDialogComponent implements OnInit {

  @Input() paidClient?: boolean = false;
  constructor(
    private _activeModal: DbActiveModal
  ) { }

  ngOnInit() {
  }

  public close(): void {
    this._activeModal.close();
  }

  public cancel(): void {
    this._activeModal.dismiss();
  }

}
